import { Navigate } from 'react-router';

function detectLocale(): 'en' | 'it' {
  const browserLang = navigator.language || (navigator as any).userLanguage || 'en';
  return browserLang.toLowerCase().startsWith('it') ? 'it' : 'en';
}

export const LocaleRedirect = () => {
  const locale = detectLocale();
  return <Navigate to={`/${locale}`} replace />;
};
